export const pluralize = (
  count: number,
  noun: string,
  suffix = "s",
  withCount = true,
) => {
  const form = `${noun}${count !== 1 ? suffix : ""}`;
  return withCount ? `${count} ${form}` : form;
};
